import React, { forwardRef, type ComponentProps } from 'react';
import { Arrow } from '@radix-ui/react-dropdown-menu';
import { cn } from '@mentimeter/ragnar-tailwind-config';

export type DropdownMenuArrowProps = ComponentProps<typeof Arrow>;

export const DropdownMenuArrow = forwardRef<
  SVGSVGElement,
  DropdownMenuArrowProps
>((props: DropdownMenuArrowProps, ref) => {
  const { className, ...rest } = props;
  return (
    <Arrow
      ref={ref}
      className={cn('fill-(--color-surface)', className)}
      {...rest}
    />
  );
});
